import { defineComponent, ref } from 'vue'
import './style.sass'

export default defineComponent({
    setup() {

        const isAuthorized = ref(localStorage.AuthClient)

        return () => {
            return (
                <div class="mobile-fixed-menu">
                    {isAuthorized.value &&
                        <a class="mobile-fixed-menu-item" data-mobile-menu>
                            <div class="mobile-fixed-menu-img mobile-fixed-menu-menu-img" data-mobile-menu></div>
                            Меню
                        </a>
                    }
                    <a href="https://cable.ru/cart/" class="mobile-fixed-menu-item">
                        <div class="mobile-fixed-menu-img mobile-fixed-menu-cart-img"></div>
                        Корзина
                    </a>
                    <a href="tel:+7 (495) 646-08-58" class="mobile-fixed-menu-item">
                        <div class="mobile-fixed-menu-img mobile-fixed-menu-phone-img"></div>
                        Звонок
                    </a>
                </div>
            )
        }
    }
})